import { queryOptions, type QueryClient } from '@tanstack/react-query';
import { NETWORK_STALE_TIME } from '../usage/queries';
import type { Seller } from './model';
import { fetchSeller, fetchSellers } from './repository';

export const sellersQueryOptions = () =>
  queryOptions({
    queryKey: ['sellers'] as const,
    queryFn: fetchSellers,
    staleTime: NETWORK_STALE_TIME,
  });

export const sellerQueryOptions = (slug: string) =>
  queryOptions({
    queryKey: ['sellers', slug] as const,
    queryFn: () => fetchSeller(slug),
    staleTime: NETWORK_STALE_TIME,
  });

/** Route-loader resolution, so the list server-renders. Never rejects: an
 *  unreachable list renders the page's unavailable state, not an error page. */
export const loadSellers = (queryClient: QueryClient): Promise<unknown> =>
  queryClient.ensureQueryData(sellersQueryOptions()).catch(() => undefined);

/** Route-loader resolution of one seller page: the seller, null when no listed
 *  seller has the slug, or undefined when the gateway could not be reached. */
export const loadSeller = (queryClient: QueryClient, slug: string): Promise<Seller | null | undefined> =>
  queryClient.ensureQueryData(sellerQueryOptions(slug)).catch(() => undefined);
